import { Box, CircularProgress, CssBaseline, Stack, ThemeProvider } from '@mui/material'

import { useNavigate, useParams } from 'react-router-dom'
import { pixelSizings } from '../../components/AppLayout/AppLayout'
import theme from '../../sharedComponents/src/Theme/theme-v2'
import { LoginState } from '../../sharedComponents/src/globalHeader/GlobalHeader'
import { useStoreState } from '../../store/hooks'

import { useEffect } from 'react'
import { useScreenSize } from '../../sharedComponents/src/hooks/useScreenSize'
import { Account, GameHistory, Missions, Stats } from './sections'

export enum PROFILE_SECTIONS {
    MISSIONS = 'missions',
    STATS = 'stats',
    GAME_HISTORY = 'game-history',
    ACCOUNT = 'account',
}

const Sections: Record<PROFILE_SECTIONS, JSX.Element> = {
    [PROFILE_SECTIONS.MISSIONS]: <Missions />,
    [PROFILE_SECTIONS.ACCOUNT]: <Account />,
    [PROFILE_SECTIONS.STATS]: <Stats />,
    [PROFILE_SECTIONS.GAME_HISTORY]: <GameHistory />,
}

export const ProfileViewV2 = () => {
    const userData = useStoreState((state) => state.userData)
    const { isMobile } = useScreenSize()
    const navigate = useNavigate()

    const { section = PROFILE_SECTIONS.MISSIONS } = useParams<{ section: PROFILE_SECTIONS }>()

    useEffect(() => {
        if (section && !Sections[section]) {
            navigate('/profile/missions')
        }
    }, [section])

    // Show loading spinner if login state is not logged in
    if (userData.state !== LoginState.LOGGED_IN) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: `calc(100dvh - ${pixelSizings.margin} / 4 - ${isMobile ? pixelSizings.mobileHeader : pixelSizings.desktopHeader})`,
                }}
            >
                <CircularProgress style={{ width: '100px', height: '100px' }} />
            </Box>
        )
    }

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Stack
                direction="row"
                gap={2.5}
                px={{ xs: 1.5, md: 0 }}
                pt={1}
                mx="auto"
                maxWidth="1024px"
                display="flex"
                justifyContent="center"
                // height={{
                //     xs: `calc(100dvh - ${pixelSizings.mobileHeader})`,
                //     md: `calc(100dvh - ${pixelSizings.desktopHeader})`,
                // }}
            >
                <Stack direction="column" width="100%" sx={{ overflow: 'visible' }}>
                    {Sections[section]}
                </Stack>
            </Stack>
        </ThemeProvider>
    )
}
